<div class="logo-container">
    <img src="assets/images/logo/zenity-logo.svg" alt="small logo" />
    <div class="large-logo-mask">
        <img class="large-logo" src="assets/images/logo/zenity-text.svg" alt="large logo" />
    </div>
</div>

<div #menuitems role="menubar" class="menu-items">
    <div
        #selectedindicator
        class="selected-indicator"
        [style.--selected-index-top.px]="selectedIndexTop"
        [style.--selected-index-height.px]="selectedIndexHeight"></div>
    <app-nav-menu-item *ngFor="let appPage of appPages; let i = index" [appPage]="appPage" [isMenuExpanded]="isMenuExpanded" [index]="i">
    </app-nav-menu-item>
</div>

<div class="spacer"></div>

<div class="menu-bottom" role="menubar">
    <app-nav-menu-item *ngFor="let externalRefPage of externalRefPages" [appPage]="externalRefPage" [isMenuExpanded]="isMenuExpanded">
    </app-nav-menu-item>
</div>

<div class="menu-footer">© Zenity Ltd. {{ currentYear }}</div>
